import { render, staticRenderFns } from "./StringsForBs.vue?vue&type=template&id=f22c8924&scoped=true&"
import script from "./StringsForBs.vue?vue&type=script&lang=js&"
export * from "./StringsForBs.vue?vue&type=script&lang=js&"
import style0 from "./StringsForBs.vue?vue&type=style&index=0&id=f22c8924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22c8924",
  null
  
)

export default component.exports